import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState, useCallback, useLayoutEffect } from 'react';
import { PropTypes } from 'react-desc';
import DSTextBox from '../../TextBox/DSTextBox.js';
import setCaretPosition from '../utils/setCaretPosition.js';
import '../../Input/DSInput.js';
import '../../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../../Input/showEllipsis.js';

var conformValue = function conformValue(rawValue, cursorPos, lastkeycode) {
  var nextMaskedValue = rawValue.split('').filter(function (char) {
    return char >= '0' && char <= '9';
  }).slice(0, 8);
  var maskedPos = 0;

  for (var i = 0; i < cursorPos; i += 1) {
    if (nextMaskedValue[maskedPos] === rawValue[i]) maskedPos += 1;
  } // list of [string to add, position to add]


  var charactersToAdd = [['/', 2], ['/', 5]];
  charactersToAdd.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        chars = _ref2[0],
        pos = _ref2[1];

    if (nextMaskedValue.length > pos) {
      nextMaskedValue.splice(pos, 0, chars);
      if (maskedPos >= pos) maskedPos += chars.length;
    }
  });

  if (lastkeycode !== 8 && maskedPos < nextMaskedValue.length) {
    charactersToAdd.forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          chars = _ref4[0],
          pos = _ref4[1];

      if (maskedPos === pos) maskedPos += chars.length;
    });
  } else if (lastkeycode === 8 && maskedPos) {
    charactersToAdd.forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          chars = _ref6[0],
          pos = _ref6[1];

      if (maskedPos === pos + 1) maskedPos -= chars.length;
    });
  }

  return {
    nextMaskedValue: nextMaskedValue.join(''),
    maskedPos: maskedPos
  };
};

var DateInputMask = function DateInputMask(_ref7) {
  var focus = _ref7.focus,
      setFocus = _ref7.setFocus,
      setRawMask = _ref7.setRawMask,
      cursorPosition = _ref7.cursorPosition,
      setCursorPosition = _ref7.setCursorPosition,
      lastkey = _ref7.lastkey,
      setLastkey = _ref7.setLastkey,
      setRawValue = _ref7.setRawValue,
      style = _ref7.style,
      disabled = _ref7.disabled,
      className = _ref7.className,
      name = _ref7.name,
      maxLength = _ref7.maxLength,
      minLength = _ref7.minLength,
      fluidWidth = _ref7.fluidWidth,
      placeholder = _ref7.placeholder,
      onKeyDown = _ref7.onKeyDown,
      onClick = _ref7.onClick,
      onChange = _ref7.onChange,
      onFocus = _ref7.onFocus,
      onBlur = _ref7.onBlur,
      onPaste = _ref7.onPaste,
      onKeyUp = _ref7.onKeyUp,
      hasError = _ref7.hasError,
      readOnly = _ref7.readOnly,
      type = _ref7.type,
      _innerRef = _ref7.innerRef,
      _ref7$clearable = _ref7.clearable,
      clearable = _ref7$clearable === void 0 ? false : _ref7$clearable,
      leftComponent = _ref7.leftComponent,
      rightComponent = _ref7.rightComponent,
      value = _ref7.value,
      rest = _objectWithoutProperties(_ref7, ["focus", "setFocus", "setRawMask", "cursorPosition", "setCursorPosition", "lastkey", "setLastkey", "setRawValue", "style", "disabled", "className", "name", "maxLength", "minLength", "fluidWidth", "placeholder", "onKeyDown", "onClick", "onChange", "onFocus", "onBlur", "onPaste", "onKeyUp", "hasError", "readOnly", "type", "innerRef", "clearable", "leftComponent", "rightComponent", "value"]);

  var inputRef = useRef();

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      maskedValue = _useState2[0],
      setMaskedValue = _useState2[1];

  var conform = useCallback(function (_ref8) {
    var rawValue = _ref8.rawValue,
        cursorPos = _ref8.cursorPos,
        lastkeycode = _ref8.lastkeycode,
        _ref8$shouldUpdateCur = _ref8.shouldUpdateCursorPos,
        shouldUpdateCursorPos = _ref8$shouldUpdateCur === void 0 ? true : _ref8$shouldUpdateCur;

    var _conformValue = conformValue(rawValue, cursorPos, lastkeycode),
        nextMaskedValue = _conformValue.nextMaskedValue,
        maskedPos = _conformValue.maskedPos;

    var event = {
      target: {
        value: nextMaskedValue,
        originalValue: rawValue
      }
    };
    if (onChange && nextMaskedValue !== maskedValue) onChange(event);
    setMaskedValue(nextMaskedValue);
    setRawValue(nextMaskedValue);
    if (shouldUpdateCursorPos) setCursorPosition({
      current: maskedPos
    });
  }, [maskedValue, onChange]);
  var handleOnChange = useCallback(function (e) {
    var _e$target = e.target,
        rawValue = _e$target.value,
        selectionEnd = _e$target.selectionEnd;
    setRawMask(rawValue);
    setRawValue(rawValue);
    setCursorPosition({
      current: selectionEnd
    });
    setFocus(true);
  }, [setRawMask, setRawValue, setCursorPosition, setFocus, lastkey.code]);
  useLayoutEffect(function () {
    if (focus) setCaretPosition(inputRef.current, cursorPosition.current);
  }, [focus, cursorPosition]);
  useLayoutEffect(function () {
    // if the value changes, then re-conform the mask
    conform({
      rawValue: value,
      cursorPos: cursorPosition.current,
      lastkeycode: lastkey.code,
      shouldUpdateCursorPos: focus
    });
  }, [focus, value, cursorPosition.current]);
  var handleKeyDown = useCallback(function (e) {
    e.stopPropagation();
    setLastkey({
      key: e.key,
      code: e.keyCode
    });
    onKeyDown(e);
  }, [onKeyDown]);
  var handleBlur = useCallback(function (e) {
    setFocus(false);
    onBlur(e);
  }, [onBlur]);
  return /*#__PURE__*/React.createElement(DSTextBox, _extends({}, rest, {
    className: className,
    clearable: clearable,
    disabled: disabled,
    fluidWidth: fluidWidth,
    hasError: hasError,
    innerRef: function innerRef(ref) {
      inputRef.current = ref;
      if (_innerRef) _innerRef(ref);
    },
    isActive: focus,
    leftComponent: leftComponent,
    maxLength: maxLength,
    minLength: minLength,
    name: name,
    onBlur: handleBlur,
    onChange: handleOnChange,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: onKeyUp,
    onPaste: onPaste,
    placeholder: placeholder,
    readOnly: readOnly,
    rightComponent: rightComponent,
    style: style,
    type: type,
    value: maskedValue
  }));
};

DateInputMask.propTypes = {
  focus: PropTypes.bool,
  setFocus: PropTypes.func,
  setRawMask: PropTypes.func,
  cursorPosition: PropTypes.shape({
    current: PropTypes.number
  }),
  setCursorPosition: PropTypes.func,
  lastkey: PropTypes.shape({
    code: PropTypes.number,
    key: PropTypes.string
  }),
  setLastkey: PropTypes.func,
  setRawValue: PropTypes.func,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  fluidWidth: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  leftComponent: PropTypes.element,
  rightComponent: PropTypes.element,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onPaste: PropTypes.func,
  onKeyUp: PropTypes.func,
  hasError: PropTypes.bool,
  readOnly: PropTypes.bool,
  onClick: PropTypes.func,
  clearable: PropTypes.bool,
  type: PropTypes.string,
  innerRef: PropTypes.any,
  mask: PropTypes.any,
  placeholderChar: PropTypes.string
};

export default DateInputMask;
//# sourceMappingURL=DateInputMask.js.map
